let AllEnvApiUrls = {
  production: {
    baseUrl: process.env.REACT_APP_PROD_USER_API_URL,
  },
  staging: {
    baseUrl: process.env.REACT_APP_STAG_USER_API_URL,
  },
  development: {
    baseUrl: process.env.REACT_APP_DEV_USER_API_URL,
  },
};

const environment = process.env.REACT_APP_ENVIRONMENT || "development";
const ApiUrls = AllEnvApiUrls[environment];

if (!ApiUrls?.baseUrl) {
  console.error(`Error: API URL for environment "${environment}" is not defined. Check your .env file for REACT_APP_ENVIRONMENT and REACT_APP_DEV_USER_API_URL.`);
}

const UserAuthUrl = `${ApiUrls?.baseUrl}/user-service/v1`;

export const URLS = {
  // Auth APIs
  register: `${UserAuthUrl}/auth/register`,
  login: `${UserAuthUrl}/auth/login`,
  forgotPassword: `${UserAuthUrl}/auth/forget-password`,
  logout: `${UserAuthUrl}/auth/logout`,
  userDetails: `${UserAuthUrl}/user/UserDetails`,
  change_password: `${UserAuthUrl}/auth/change-password`,

  // User profile
  createUserProfile: `${UserAuthUrl}/user/userProfile`,
  getcities: `${UserAuthUrl}/country/getcities`,
  get_userProfile: `${UserAuthUrl}/user/userProfile`,
  create_userProfile: `${UserAuthUrl}/user/userProfile`,
  uploadImage: `${UserAuthUrl}/user/userImage`,
  uploadUserResume: `${UserAuthUrl}/user/user-resume`,
  getUserResume: `${UserAuthUrl}/user/download-resume`,

  // Job API's
  getAllJob: `${UserAuthUrl}/user/getAllJob`,
  getSingleJob: `${UserAuthUrl}/user/getSingleJob`,
  userJobApplie: `${UserAuthUrl}/user/userJobApplie`,
  getAllAppliedJobs: `${UserAuthUrl}/user/getAllAppliedJobs`,
  getSkillList: `${UserAuthUrl}/user/getSkillslist`,
  getJoblist: `${UserAuthUrl}/user/getJoblist`,
  notInterestedJob: `${UserAuthUrl}/user/notInterestedJob`,
  getNotInterestedJob: `${UserAuthUrl}/user/getNotInterestedJob`,
  saveLater: `${UserAuthUrl}/user/saveLater`,
  getSaveLater: `${UserAuthUrl}/user/getSaveLater`,
  getTopCompaniesLogo: `${UserAuthUrl}/user/getTopCompaniesLogo`,
  getPostsByCompaniyId: `${UserAuthUrl}/user/getPostsByCompaniyId`,
  getSearchBySkills: `${UserAuthUrl}/user/getAllJob`,

  // Langauge
  getLanguages: `${UserAuthUrl}/language/getLanguages`,

  // Notification
  saveFcmTokenUser: `${UserAuthUrl}/fcmToken/fcmDeviceToken`,
  deleteFcmTokenUser: `${UserAuthUrl}/fcmToken/fcmDeviceToken`,
  getNotificationUser: `${UserAuthUrl}/fcmToken/getNotifications`,
  readNotificationUser: `${UserAuthUrl}/fcmToken/readNotification`,
  readAllNotificationsUser: `${UserAuthUrl}/fcmToken/readAllNotifications`,
  sendNotificationUser: `${UserAuthUrl}/fcmToken/sendNotification`,
  deleteNotificationByIdUser: `${UserAuthUrl}/fcmToken/deleteNotificationById`,
  deleteAllNotificationUser: `${UserAuthUrl}/fcmToken/deleteNotification`,
};
